import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const comparisonTextSearchSchema = z.object({
  selectedId: z.string().optional().catch(undefined),
  view: z.enum(['item']).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/comparison/$comparisonId/text'
)({
  validateSearch: (raw) => comparisonTextSearchSchema.parse(raw),
})
